import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 1,
      title: 'Create New Event',
      description: 'Set up a new event with tickets and pricing',
      icon: 'Plus',
      color: 'bg-primary text-primary-foreground',
      link: '/event-creation',
      featured: true
    },
    {
      id: 2,
      title: 'Manage Events',
      description: 'Edit existing events and view performance',
      icon: 'Settings',
      color: 'bg-secondary text-secondary-foreground',
      link: '/event-management'
    },
    {
      id: 3,
      title: 'View Analytics',
      description: 'Detailed insights and revenue reports',
      icon: 'BarChart3',
      color: 'bg-accent text-accent-foreground',
      link: '/host-dashboard'
    },
    {
      id: 4,
      title: 'Attendee Management',
      description: 'Check-in attendees and manage guest lists',
      icon: 'Users',
      color: 'bg-success text-success-foreground',
      link: '/attendee-management'
    }
  ];

  const quickStats = [
    { label: 'Pending Check-ins', value: '23', icon: 'Clock' },
    { label: 'New Messages', value: '5', icon: 'MessageCircle' },
    { label: 'Refund Requests', value: '2', icon: 'AlertCircle' }
  ];

  return (
    <div className="space-y-6">
      {/* Primary Actions */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
          <p className="text-sm text-muted-foreground">Manage your events and business</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {actions?.map((action) => (
            <Link
              key={action?.id}
              to={action?.link}
              className={`group relative overflow-hidden rounded-lg p-6 transition-all duration-300 hover:scale-105 hover:shadow-lg ${
                action?.featured 
                  ? 'bg-gradient-to-br from-primary to-primary/80 text-primary-foreground' 
                  : 'bg-muted hover:bg-muted/80'
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="space-y-2">
                  <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
                    action?.featured 
                      ? 'bg-white/20' :'bg-primary/10'
                  }`}>
                    <Icon 
                      name={action?.icon} 
                      size={24} 
                      className={action?.featured ? 'text-white' : 'text-primary'} 
                    />
                  </div>
                  
                  <div>
                    <h4 className={`font-semibold ${
                      action?.featured ? 'text-white' : 'text-foreground'
                    }`}>
                      {action?.title}
                    </h4>
                    <p className={`text-sm ${
                      action?.featured ? 'text-white/80' : 'text-muted-foreground'
                    }`}>
                      {action?.description}
                    </p>
                  </div>
                </div>
                
                <Icon 
                  name="ArrowRight" 
                  size={20} 
                  className={`transition-transform group-hover:translate-x-1 ${
                    action?.featured ? 'text-white/60' : 'text-muted-foreground'
                  }`} 
                />
              </div>
              
              {action?.featured && (
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
              )}
            </Link>
          ))}
        </div>
      </div>
      {/* Quick Stats */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-foreground">Attention Required</h3>
          <p className="text-sm text-muted-foreground">Items that need your review</p>
        </div>

        <div className="space-y-3">
          {quickStats?.map((stat, index) => (
            <div key={index} className="flex items-center justify-between p-3 rounded-lg bg-muted/50 hover:bg-muted transition-smooth">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-warning/10 rounded-lg">
                  <Icon name={stat?.icon} size={16} className="text-warning" />
                </div>
                <span className="text-sm font-medium text-foreground">{stat?.label}</span>
              </div>
              
              <div className="flex items-center space-x-2">
                <span className="text-lg font-bold text-warning">{stat?.value}</span>
                <Button variant="ghost" size="xs">
                  <Icon name="ChevronRight" size={14} />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 pt-4 border-t border-border">
          <Button variant="outline" fullWidth>
            <Icon name="Bell" size={16} className="mr-2" />
            View All Notifications
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;